var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "modal",
    {
      staticClass: "modal-confirmation",
      attrs: {
        show: _vm.show,
        title: _vm.translatedModalTitle,
        saveButton: {
          title: "Sim",
          btnClass: { "btn btn-main btn-rounded btn-sm z-depth-0": true },
        },
        cancelButton: {
          title: "Não",
          btnClass: {
            "btn btn-outline-main btn-rounded btn-outline btn-sm z-depth-0": true,
          },
        },
        size: "small",
        needHeader: false,
        relativeBackdrop: true,
        contentCentered: true,
      },
      on: { close: _vm.onClose, save: _vm.onConfirm },
    },
    [_c("p", { domProps: { innerHTML: _vm._s(_vm.translatedText) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }